<template>
  <validation-observer
    ref="checkExaminationModalFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="checkExaminationModal"
      centered
      title="Phúc khảo điểm thi"
      size="lg"
      body-class="position-static"
      @hide="reason = ''"
    >
      <b-form>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mb-1"
              @click="onDownload"
            >
              <span class="text-right">
                <feather-icon icon="DownloadIcon" /> Mẫu đơn phúc khảo
              </span>
            </b-button>
          </b-col>
        </b-row>
        <b-form-group label-for="name-input">
          <template v-slot:label>
            Lý do <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Lý do"
            rules="required"
          >
            <b-form-input
              id="name-input"
              v-model="reason"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label-for="file-input"
            >
              <template v-slot:label>
               File <span class="text-danger">*</span>
              </template>
              <b-form-file
                id="file-input"
                ref="inputFileRef"
                placeholder="Chọn đơn phúc khảo"
                @change="uploadFile"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Gửi yêu cầu
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('checkExaminationModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BFormInput, BModal, BOverlay, BFormGroup, BForm, BButton, BFormFile, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { Flag } from '@/const/flag'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'StudentCheckExamination',
  components: {
    ValidationObserver,
    ValidationProvider,
    BModal,
    BFormInput,
    BOverlay,
    BFormGroup,
    BForm,
    BButton,
    BFormFile,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  props: {
    studentExaminationRoomId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      reason: '',
      required,
      mediaIds: [],
    }
  },
  computed: {
    ...mapGetters({
      documents: 'documents/documents',
    }),
  },

  async created() {
    await this.getDocuments({
      currentPage: 1,
      itemsPerPage: 10,
      search: 'Mẫu đơn phúc khảo',
    })
  },
  methods: {
    ...mapActions({
      getDocuments: 'documents/getDocuments',
      createStudentCheckExamination: 'studentCheckExamination/createStudentCheckExamination',
      uploadDocument: 'studentCheckExamination/uploadDocument',
    }),
    async onDownload() {
      try {
        const fileUrl = this.documents[0].url
        const link = document.createElement('a')
        link.href = fileUrl
        link.setAttribute('download', 'Mẫu-đơn-phúc-khảo.docx')
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code || 'Lỗi'}] ${e.message || 'Không thể tải file'}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },

    async uploadFile(e) {
      this.isLoading = true
      const formData = new FormData()
      const { files } = e.target
      if (files.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'File tài liệu đang bị trống',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        this.isLoading = false
        return
      }
      files.forEach(file => formData.append('files', file))
      const { data, message } = await this.uploadDocument(formData)
      this.mediaIds = data
      if (this.mediaIds.length > 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${message}`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
      this.isLoading = false
    },

    onSave() {
      this.$swal({
        title: 'Bạn muốn gửi yêu cầu phúc khảo?',
        text: 'Vui lòng kiểm tra lại thông tin trước khi gửi yêu cầu',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          const valid = this.$refs
            .checkExaminationModalFormRef
            .validate()
          if (valid) {
            if (this.mediaIds.length > 0) {
              this.isLoading = true
              try {
                const response = await this.createStudentCheckExamination({
                  studentExaminationRoomId: this.studentExaminationRoomId,
                  mediaId: this.mediaIds[0],
                  description: this.reason,
                  status: Flag.ACTIVE,
                })
                if (response) {
                  const { isSuccessful, message } = response
                  if (isSuccessful) {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: message,
                        icon: 'CheckIcon',
                        variant: 'success',
                      },
                    })
                    this.$bvModal.hide('checkExaminationModal')
                    this.$emit('succeed')
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: message,
                        icon: 'XCircleIcon',
                        variant: 'danger',
                      },
                    })
                  }
                }
              } catch (e) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `[${e.code}] ${e.message}`,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              } finally {
                this.isLoading = false
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Vui lòng chọn file',
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        }
      })
    },
  },
}
</script>
